import React from 'react';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class SAButton extends React.Component {

  render() {
    const {type, htmlType='button', brand='bmw', className, ...attributes} = this.props;

    const primaryClassName = (type === 'primary') ? `btn-primary-${brand}` : `btn-secondary-${brand}`

    return (
        <button type={htmlType} className={`btn ${className} ${primaryClassName}`} {...attributes}/>

    )
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  brand: state.publicContext && state.publicContext.brand,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SAButton)
);
